import { render, staticRenderFns } from "./WVUH.vue?vue&type=template&id=4005e547&scoped=true"
import script from "./WVUH.vue?vue&type=script&lang=js"
export * from "./WVUH.vue?vue&type=script&lang=js"
import style0 from "./WVUH.vue?vue&type=style&index=0&id=4005e547&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4005e547",
  null
  
)

export default component.exports